<template>
  <div class="electiveOperationList">
    <div class="nav">
      <div class="title">
        <i class="iconfont icon-shoushugongzuoliang"></i>
        <p>手术信息</p>
      </div>
      <div class="line"></div>
    </div>
    <div class="search">
      <el-col :span="8">
        <span class="dateTitle">手术时间</span>
        <el-date-picker
          clearable
          v-model="searchDate"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        ></el-date-picker>
      </el-col>

      <el-col :span="3" class="searchInput">
        <el-input v-model="searchDoctor" placeholder="手术医生" prefix-icon="el-icon-search" clearable></el-input>
      </el-col>
      <el-col :span="3" class="searchInput">
        <el-input v-model="searchPatients" placeholder="患者姓名/ID" prefix-icon="el-icon-search" clearable></el-input>
      </el-col>
      <el-col :span="4" class="searchInput">
        <el-input v-model="searchNote" placeholder="备注信息" prefix-icon="el-icon-search" clearable></el-input>
      </el-col>

      <el-col :span="6" class="btnBottom">
        <button
          class="btn iconfont leftItemSubmit yuyuetips"
          style="padding: 0"
          @click.prevent="refreshList"
          v-show="hasNewElective"
        >
          有新预约
          <i class="iconfont icon-004shuaxin"></i>
        </button>
        <button
          class="btn iconfont leftItemSubmit"
          @click.prevent="handleSurgeryAppointment"
          style="padding: 0;margin-right: 8px"
          v-acl="['surgery_appointment']"
        >手术量编辑</button>
        <button
          class="btn iconfont leftItemSubmit"
          @click.prevent="exportExcel()"
          style="padding: 0"
        >导出Excel</button>
      </el-col>
    </div>
    <div class="line lineGray"></div>
    <div class="fotter">
      <template>
        <el-table :data="tableData" stripe style="width: 100%" @cell-dblclick="dbclickCell">
          <el-table-column type="index" label="序号" width="60"></el-table-column>
          <el-table-column
            v-for="(item,index) in tableTitle"
            :key="index"
            :prop="item.prop"
            :label="item.label"
            :width="item.width-100"
          ></el-table-column>
          <el-table-column label="操作" width="80">
            <template slot-scope="scope">
              <el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">
                <i class="el-icon-delete"></i>
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
                @current-change="handleCurrentChange"
                :current-page="this.pageNumber"
                :page-size="this.pageSize"
                layout="total, prev, pager, next, jumper"
                :total="this.pageTotal">
        </el-pagination>
      </template>
<!--      <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="this.pageNumber"
              :page-size="this.pageSize"
              layout="total, prev, pager, next,jumper"
              :total="this.pageTotal">
      </el-pagination>-->

  <!--    <div class="pageFen">
        <el-button-group>
          <el-button type="primary" icon="el-icon-arrow-left" @click="clickPrev">上一页</el-button>
          <el-button type="primary" @click="clickNext">
            下一页
            <i class="el-icon-arrow-right el-icon&#45;&#45;right"></i>
          </el-button>
        </el-button-group>
      </div>-->
    </div>
    <SurgeryAppointment
      :isShowSurgeryAppointment="isShowSurgeryAppointment"
      @closeSurgeryAppointment="closeSurgeryAppointment"
    ></SurgeryAppointment>
  </div>
</template>
<script>
import removeOperation from "../gql/removeOperation.gql";
import getOperationList from "../gql/getOperationList.gql";
import knowledgeDicTemplate from "../utils/knowledgeDicTemplate.js";
import moment from "moment";
import printExcel from "../utils/printExcel.js";
import SurgeryAppointment from './SurgeryAppointment.vue';
let times ;
export default {
  name: "electiveOperationList",
  data() {
    return {
      tableTitle: [
        { prop: "operation_status", label: "状态", width: "148" },
        { prop: "operation_date", label: "手术日期", width: "200" },
        { prop: "am_pm", label: "时段", width: "160" },
        { prop: "name", label: "姓名", width: "180" },
        { prop: "sex", label: "性别", width: "148" },
        { prop: "id_in_hospital", label: "ID号", width: "5%" },
        { prop: "diagnoses", label: "诊断", width: "5%" },
        { prop: "operation_name", label: "手术名称", width: "5%" },
        { prop: "operation_position", label: "手术部位", width: "5%" },
        { prop: "sign_doctor", label: "首诊医生", width: "200" },
        { prop: "operation_doctor", label: "手术医生", width: "200" },
        { prop: "operation_fee1", label: "手术费用", width: "180" },
        { prop: "record_person", label: "登记者", width: "200" },
        { prop: "create_time", label: "添加时间", width: "200" },
        { prop: "note", label: "备注", width: "200" }
      ],
      formInline: {},
      searchDate: "",
      searchPatients: "",
      searchDoctor: "",
      searchNote:"",
      searchAmPm:"",
      tableData: [],
      pageSize: 9,
      pageTotal:0,
      pageNumber: 1,
      searchStartDate: "",
      searchEndDate: "",
      isShowSurgeryAppointment: false,
    };
  },
  components: {
    SurgeryAppointment,
  },
  mixins: [knowledgeDicTemplate, printExcel],
  created() {
    this.$root.$on("refreshOperationList", async () => {
      this.tableData = await this.getList();
    });
  },
  beforeDestroy() {
    this.$root.$off("refreshOperationList");
  },
  async mounted() {
    await this.getKnowledgeDic();
    await this.queryMyTemplate();
    // alert( document.body.clientHeight)
    this.tableData = await this.getList();
  },
  watch: {
    async searchPatients(newVal) {
      this.pageNumber = 1
      this.tableData = await this.getList();
    },
    async searchDoctor(newVal) {
      this.searchDoctor = newVal
      this.pageNumber = 1
      this.tableData = await this.getList();
    },
    async searchDate(newVal) {
      if (newVal) {
        this.searchStartDate = moment(newVal[0]).format("YYYY-MM-DD");
        this.searchEndDate = moment(newVal[1]).format("YYYY-MM-DD");
      } else {
        this.searchStartDate = "";
        this.searchEndDate = "";
      }
      this.pageNumber = 1
      this.tableData = await this.getList();
    },

    async searchNote(newVal) {
      this.searchNote = newVal
      this.pageNumber = 1
      this.tableData = await this.getList();
    },
    async searchAmPm(newVal) {
      this.searchAmPm = newVal
      this.pageNumber = 1
      this.tableData = await this.getList();
    },

    async hasNewElective(val) {
      if (val) {
        await this.refreshList();
      }
    }
  },
  computed: {
    hasNewElective() {
      return this.$store.state.hasNewElective;
    }
  },
  methods: {
    async handleSizeChange(val) {
      this.pageNumber = val;
      this.pageSize = val
      this.tableData = await this.getList();
    },
    async handleCurrentChange(val) {
      this.pageNumber = val;
      this.tableData = await this.getList();
    },
    // 处理手术预约
    handleSurgeryAppointment() {
      this.isShowSurgeryAppointment = true;
    },
    // 关闭手术预约窗口
    closeSurgeryAppointment() {
      this.isShowSurgeryAppointment = false;
    },
    async handleDelete(index, row) {
      this.$confirm("此操作将永久删除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          await this.deleteOpedration(row.id, index);
        })
        .catch(() => {
          // console.log('取消');
        });
    },
    async deleteOpedration(id, index) {
      try {
        let res = await this.$apollo.mutate({
          mutation: removeOperation,
          variables: {
            id
          }
        });
        // console.log(res)
        if (res.data.removeOperation) {
          this.tableData.splice(index, 1);
          this.$message.success("已删除");
        }
      } catch (error) {
        console.log(error);
        this.$message.error("请重试");
      }
    },
    async clickPrev() {
      if (this.pageNumber === 1) {
        this.$message("已经是首页了");
      } else {
        this.pageNumber -= 1;
        this.tableData = await this.getList();
      }
    },
    async clickNext() {
      if (this.tableData.length < 15) {
        this.$message("已经是最后一页了");
      } else {
        this.pageNumber += 1;
        this.tableData = await this.getList();
      }
    },
    async refreshList() {
      this.searchDate = "";
      this.searchPatients = "";
      this.searchDoctor = "";
      this.pageSize = 15;
      this.pageNumber = 1;
      this.searchStartDate = "";
      this.searchEndDate = "";
      this.searchNote = "";
      this.searchAmPm = "";
      this.pageNumber = 1;
      this.tableData = await this.getList();
      this.$store.commit("sethasNewElective", false);
    },
    dbclickCell(row, column, cell, event) {
      clearInterval(times)
      if (this.$store.state.operationInput) {
            times= setTimeout(() => {
               this.dbclickCell(row, column, cell, event)
            }, 300);
      } else {
        this.$store.commit("setoperationClearClick", true);
        this.$store.commit("seteditOperation", true);
        this.$store.commit("setoperationPatientId", row.patient_id);
        this.$store.commit("setoperationElectiveId", row.id);
        this.$store.commit("setoperationRelevantId", row.relevant_info[0].id);
      }
    },
    async getList() {
      try {
        let queryObj = {
          page_size: this.pageSize,
          page_number: this.pageNumber,
          operation_doctor: this.searchDoctor,
          patient_name_id: this.searchPatients
        };
        if (this.searchDate) {
          queryObj.time_start = this.searchStartDate;
          queryObj.time_end = this.searchEndDate;
        }
        if (this.searchNote) {
          queryObj.note = this.searchNote;
        }
        if (this.searchAmPm) {
          queryObj.am_pm = this.searchAmPm;
        }

        let res = await this.$apollo.query({
          query: getOperationList,
          variables: queryObj,
          fetchPolicy: "no-cache"
        });
        let newData = res.data.operationinfo.data;
        this.pageTotal = res.data.operationinfo.count
        for (const A of newData) {
          A.operation_date = moment(A.operation_date).format("YYYY-MM-DD");
          A.create_time = moment(A.create_time).format("YYYY-MM-DD");
          A.name = A.patient_info[0].name;
          A.id_in_hospital = A.patient_info[0].id_in_hospital;
          A.sex = A.patient_info[0].gender;
          A.diagnoses = A.relevant_info[0]
            ? this.formatConclusion(A.relevant_info[0].diagnosis)
            : "";
          A.am_pm = A.am_pm=="am"?"上午":"下午";
          if (A.operation_fee === -1) {
            A.operation_fee1 = "";
          } else {
            A.operation_fee1 = Number(A.operation_fee) * 0.01;
          }
        }
        return newData;
      } catch (error) {
        console.log(error);
        this.$message.error("列表加载失败");
      }
    }
  }
};
</script>
<style lang="less">
.electiveOperationList {
  width: 100%;
  height: 100%;

  .el-col-8 {
    padding-left: 24px;
    box-sizing: border-box;
    display: flex;
  }

  .el-form-item__label {
    color: black;
    font-weight: 600;
  }

  .el-form-item {
    width: 100% !important;
    display: flex;
    margin-top: 10px;
    padding-left: 24px;
    box-sizing: border-box;
    margin-bottom: 0;
  }

  .el-form-item__content {
    flex: 1;
  }

  .el-input input {
    width: 100%;
  }

  .el-range-editor {
    flex: 1;
    height: 36px;
  }

  .el-table {
    height: 79%;
  }

  .el-table__body-wrapper {
    height: calc(~"100% - 48px");
    overflow-y: auto;
  }
  .el-pagination {
    height: 34px !important;
    display: flex;
    justify-content: center;
    align-items: center;


    .btn-next,
    .btn-prev {
      line-height: 38px !important;
    }
  }
}
</style>
<style lang="less" scoped>
.electiveOperationList {
  .line {
    width: 100%;
    height: 2px;
    background: #4ea3c0;
  }

  .lineGray {
    background: #b8b8b8;
  }

  .nav {
    .title {
      display: flex;
      color: #4ea3c0;
      // height: 40px;
      line-height: 45px;

      i {
        text-indent: 50px;
        font-size: 30px;
      }

      p {
        text-indent: 10px;
        font-size: 18px;
      }
    }
  }

  .search {
    padding: 0 30px;
    box-sizing: border-box;
    margin-top: 12px;
    height: 48px;

    .dateTitle {
      margin-right: 10px;
      line-height: 36px;
      font-size: 14px;
      font-weight: 600;
      color: black;
    }

    .leftItemSubmit {
      height: 40px;
    }

    .searchInput {
      padding-left: 20px;
      box-sizing: border-box;
    }
  }

  .btnBottom {
    display: flex;
    justify-content: flex-end;
    position: relative;

    .yuyuetips {
      position: absolute;
      left: 24px;
    }

    // flex-direction: column-reverse;
  }

  .fotter {
    width: 100%;
    height: 100%;

    .pageFen {
      display: flex;
      justify-content: center !important;
      height: 180px;
      line-height: 37px !important;
      padding-top: 10px;
    }
  }
}
</style>
